// import React from "react";
// import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
// import AuthLayout from "./routes/middleware/AuthLayout";
// import NonAuthLayout from "./routes/middleware/NonAuthLayout";
// import { authRoutes, nonAuthRoutes, userRoutes } from "./routes/AllRoutes";
// import UserLayout from "./routes/middleware/UserLayout";
// import AuthProvider from "./context/AuthContext";
// import { Toaster } from "react-hot-toast";
// import ChatBot from "./components/ChatBot/ChatBot";
// const App = () => {
//   // Renders authenticated routes
//   const renderAuthRoutes = (routes) => {
//     return routes.map((route, idx) => (
//       <Route
//         key={idx}
//         path={route.path}
//         element={<AuthLayout>{route.component}</AuthLayout>}
//       />
//     ));
//   };

//   // Renders non-authenticated routes
//   const renderNonAuthRoutes = (routes) => {
//     return routes.map((route, idx) => (
//       <Route
//         key={idx}
//         path={route.path}
//         element={<NonAuthLayout>{route.component}</NonAuthLayout>}
//       />
//     ));
//   };

//   const ProtectedRoute = ({ children }) => {
//     const isLoggedIn = localStorage.getItem("token");

//     if (isLoggedIn) {
//       return children;
//     } else {
//       return <Navigate to="/user-login" />;
//     }
//   };

//   const renderUserRoutes = (routes) =>
//     routes.map((route, idx) => {
//       const allowWithoutLogin = route.path !== "/projects/project-details/:id";

//       return (
//         <Route
//           key={idx}
//           path={route.path}
//           element={
//             allowWithoutLogin ? (
//               <UserLayout>{route.component}</UserLayout>
//             ) : (
//               <ProtectedRoute>
//                 <UserLayout>{route.component}</UserLayout>
//               </ProtectedRoute>
//             )
//           }
//         />
//       );
//     });

//   return (
//     <React.Fragment>
//       <BrowserRouter>
//         <AuthProvider>
//           <div>
//             <Routes>
//               {renderNonAuthRoutes(nonAuthRoutes)}
//               {renderAuthRoutes(authRoutes)}
//               {renderUserRoutes(userRoutes)}
//             </Routes>
//             <Toaster></Toaster>
//           </div>
//         </AuthProvider>
//       </BrowserRouter>
//       <ChatBot />
//     </React.Fragment>
//   );
// };

// export default App;

import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AuthLayout from "./routes/middleware/AuthLayout";
import NonAuthLayout from "./routes/middleware/NonAuthLayout";
import { authRoutes, nonAuthRoutes, userRoutes } from "./routes/AllRoutes";
import UserLayout from "./routes/middleware/UserLayout";
import AuthProvider from "./context/AuthContext";
import { Toaster } from "react-hot-toast";
import ChatBot from "./components/ChatBot/ChatBot";

const App = () => {
  const renderAuthRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={<AuthLayout>{route.component}</AuthLayout>}
      />
    ));
  };

  const renderNonAuthRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={<NonAuthLayout>{route.component}</NonAuthLayout>}
      />
    ));
  };

  const renderUserRoutes = (routes) =>
    routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={<UserLayout>{route.component}</UserLayout>}
      />
    ));

  return (
    <React.Fragment>
      <BrowserRouter>
        <AuthProvider>
          <div>
            <Routes>
              {renderNonAuthRoutes(nonAuthRoutes)}
              {renderAuthRoutes(authRoutes)}
              {renderUserRoutes(userRoutes)}
            </Routes>
            <Toaster></Toaster>
          </div>
        </AuthProvider>
      </BrowserRouter>
      <ChatBot />
    </React.Fragment>
  );
};

export default App;
